module.exports = __webpack_public_path__ + "static/media/icon-plus-sign.6c085b83.svg";